import React from "react";
import classNames from "classnames";

import styles from "./Tweet.module.scss";
import Markdown from "markdown-to-jsx";
import { CreativeMarkdown } from "../../CreativeMarkdown";

export interface TweetObject {
  user: string;
  text: string;
  images: string[];
  url: string;
  retweet?: string | false;
}

interface TweetProps extends TweetObject {
  className?: string;
}

const Tweet: React.FC<TweetProps> = ({
  className,
  user,
  text,
  url,
  images,
  retweet,
}) => {
  return (
    <div className={classNames(styles.tweet, className)}>
      <div className={styles.meta}>
        <div
          className={styles.profile}
          style={{ backgroundImage: `url(${user})` }}
        />
      </div>
      <div className={styles.content}>
        {retweet && `RT @${retweet}:`}
        <CreativeMarkdown options={{ forceBlock: true }}>
          {text}
        </CreativeMarkdown>
        <a
          className={styles.permalink}
          href={url}
          target="_blank"
          rel="noreferrer noopener"
        >
          Permalink
        </a>
      </div>
      {images.length > 0 && (
        <div className={styles.media}>
          {images.map(m => (
            <div className={styles.mediaImage}>
              <img src={m} alt="" />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export { Tweet };
